module.exports = __webpack_public_path__ + "img/error.f181b18b.jpg";